// @flow
/** @jsx h */
import { h } from 'preact';
import { route } from 'preact-router';
import TilesContainer from '../tilesContainer';
import { tracker, UserActionType } from '../../../tracking';
import style from './style.css';
import CustomSlider from '../../common/customSlider';
import { connect } from 'react-redux';
import { bicRevampCategoryPage } from '../../../alias/homeRoutes';
import { useRef } from 'preact/hooks';
import EnrichCategoriesCard from '../enrichCategoryCard';
import { generateUrlWithParams } from '../../../utils/routeHandler';

const CampaignSpecificCategories = ({
  campaignId,
  pageKey,
  lenderId,
  categories,
  bicAction,
}) => {
  const customSliderRef = useRef(null);
  return (
    <TilesContainer
      title='Do More with Cardless EMI'
      subTitle='Get the convenience of Cardless EMI across all categories'
      additionalButton={false}>
      <CustomSlider
        childWidth={205}
        ref={customSliderRef}
        noOfSlides={categories.length}
        customSettings={{
          arrows: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
              },
            },
          ],
        }}>
        {categories.map((item, i) => {
          return (
            <div className={style.enrichCategoriesCardWrapper}>
              <EnrichCategoriesCard
                tileClickAction={() => {
                  tracker.trackUserInteraction(
                    UserActionType.CLICK,
                    'bic_campaign_specific_category_tile',
                    pageKey,
                    {
                      tile_name: item.name,
                      campaign_id: campaignId,
                      lender_id: lenderId,
                    },
                  );
                  return route(
                    generateUrlWithParams(bicRevampCategoryPage.path, {
                      c: item.id,
                      utm_campaign: campaignId,
                    }),
                  );
                }}
                data={item}
                index={i}
              />
            </div>
          );
        })}
      </CustomSlider>
    </TilesContainer>
  );
};
const mapStateToProps = ({ buyWithInstacred, config }) => {
  const { home } = buyWithInstacred;
  const { campaignId, categories } = home;
  const { lenderDetails } = config;
  const { lenderId } = lenderDetails || {};
  const MAX_RESULT = 15;
  return {
    campaignId,
    lenderId,
    categories:
      categories && categories.length > MAX_RESULT
        ? categories.slice(0, MAX_RESULT)
        : categories || [],
  };
};
export default connect(mapStateToProps)(CampaignSpecificCategories);



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/campaignSpecificCategories/index.js